import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import { FlexCenterWrapper, StaticWrapper } from 'wrappers';
import { Text } from 'atoms';
import Calendar from 'containers/calendar';
import { MarginRightWrapper } from 'containers/dateRangeSelector/wrappers';
import { BodyWrapper, ButtonWrapper } from './wrappers';
import controller from './controller';
import internalState from './internalState';

const containerRef = React.createRef();
const headerRef = React.createRef();

export const definition = {
  name: 'DateRangeSelector',
  controller,
  initialProps: ({ startDate, endDate, scrollLeft }) => ({ startDate, endDate, left: scrollLeft ? ((headerRef?.current?.offsetLeft ?? 0) - scrollLeft) : 0 }),
  props: internalState,
  elements: [
    {
      wrapper: FlexCenterWrapper,
      name: 'Selector',
      ref: headerRef,
      elements: [
        {
          wrapper: ButtonWrapper,
          name: 'Today',
          isButton: true,
          displayState: ({ selectedCalendar }) => ({ left: true, selected: selectedCalendar === 'today' }),
          bindings: () => ({}),
          elements: [
            {
              component: Text,
              name: 'Text',
              displayValue: () => 'Today'
            }
          ]
        },
        {
          wrapper: ButtonWrapper,
          name: 'Week',
          isButton: true,
          displayState: ({ selectedCalendar }) => ({ middle: true, selected: selectedCalendar === 'week' }),
          bindings: () => ({}),
          elements: [
            {
              component: Text,
              name: 'Text',
              displayValue: () => 'This Week'
            }
          ]
        },
        {
          wrapper: ButtonWrapper,
          name: 'All',
          isButton: true,
          displayState: ({ selectedCalendar }) => ({ middle: true, selected: selectedCalendar === 'all' }),
          bindings: () => ({}),
          elements: [
            {
              component: Text,
              name: 'Text',
              displayValue: () => 'All Time'
            }
          ]
        },
        {
          wrapper: ButtonWrapper,
          name: 'Custom',
          isButton: true,
          displayState: ({ selectedCalendar }) => ({ right: true, selected: selectedCalendar === 'custom' }),
          bindings: ({ isOpen, startDate, endDate }) => ({ isOpen, containerRef, startDate, endDate }),
          elements: [
            {
              component: Text,
              name: 'Text',
              displayValue: () => 'Custom'
            }
          ]
        }

      ]
    },
    {
      wrapper: BodyWrapper,
      name: 'Body',
      displayState: ({ left }) => ({ left }),
      ref: containerRef,
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          component: wrap(Calendar, MarginRightWrapper),
          name: 'StartCalendar',
          bindings: ({ startDate, endDate }) => ({
            selectedDate: startDate,
            selectedPeriod: startDate && endDate ? [startDate, endDate] : [],
            disabledAfter: endDate
          })
        },
        {
          component: Calendar,
          name: 'EndCalendar',
          bindings: ({ startDate, endDate }) => ({
            selectedDate: endDate,
            selectedPeriod: startDate && endDate ? [startDate, endDate] : [],
            disabledBefore: startDate
          })
        }
      ]
    }
  ]
};

const DateRangeSelector = ContainerComponent(definition);

export default wrap(DateRangeSelector, StaticWrapper);
